<template>
  <div class="hora">
    <br>
    <div class="container">
      <div class="row mt-4">
        <div class="col-4 bg-white p-4 rounded">
          <HoraLogo :is_loading="true" :haveSteps="false" :animated="true" />
        </div>
        <div class="col-8 bg-white p-4 rounded">
          <p>
            The plugin is a joint product of Saman and Soroush, and it is a comprehensive
            solution for modern Jyotish astrology. It combines the traditional techniques
            of Jyotish Vedic astrology with cutting-edge technology to provide users with
            an intelligent and user-friendly system for chart analysis.
          </p>
          <p>
            In addition, the plugin utilizes artificial intelligence to enhance its chart
            analysis system, providing users with more accurate and personalized readings.
            Whether you're a seasoned astrologer or just getting started with Jyotish
            astrology, this plugin is an excellent tool for exploring the mysteries of the
            stars.
          </p>
          Version 1.05
        </div>
      </div>

      <div class="row mt-4">
        <h3 class="w-100 mt-3 p-3 bg-white" style="text-align: center">
          سیستم تنظیمات پلاگین هوراسترو
        </h3>

        <div id="accordionExample" class="accordion p-2 border-rounded bg-white" style="border-radius: 15px;">
          <div style="padding: 10px; background-color: #ADD8E6; border-radius: 15px; margin-bottom: 15px;">
            <!-- start of Premium Chart -->
            <h4 style="width: 100%; text-align: right; color: #000; padding: 10px; text-shadow: 1px 0px 0px #fff;">
              تنظیمات تفسیر پرمیوم
            </h4>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                  aria-expanded="true" aria-controls="collapseOne">
                  تفسیر نشان ها و سیارات در نشان و خانه
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse hide" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <div class="container w-100 p-3 bg-light rounded">
                    <div class="input-group" style="direction: ltr">
                      <select v-model="selected_sign" class="form-control w-100">
                        <option value="1">Aries - 1</option>
                        <option value="2">Taurus - 2</option>
                        <option value="3">Gemini - 3</option>
                        <option value="4">Cancer - 4</option>
                        <option value="5">Leo - 5</option>
                        <option value="6">Virgo - 6</option>
                        <option value="7">Libra - 7</option>
                        <option value="8">Scorpio - 8</option>
                        <option value="9">Saggitarius - 9</option>
                        <option value="10">Capricorn - 10</option>
                        <option value="11">Aquarius - 11</option>
                        <option value="12">Pisces - 12</option>
                      </select>
                      <button type="button" class="btn btn-outline-primary" @click="loadSign">
                        Load configuration
                      </button>
                    </div>
                  </div>

                  <div v-if="sign_no" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b> Sign: {{ selected_sign_screen }} </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">

                        </div>
                      </div>
                    </div>
                  </div>



                  <div v-if="sign_no" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12 p-3" style="text-align: center; font-size: 16px">
                        <div class="w-100 bg-light p-3 mb-4">
                          <h4 class="w-100 mt-4 mb-2" style="text-align: left">
                            {{ CONDITION_TITLE }}
                          </h4>

                          <div class="input-group mb-3" style="direction: ltr">
                            <span class="input-group-text">IF PLANET</span>
                            <select v-model="planet" class="col-2" style="text-align: center">
                              <option value="Su">Su</option>
                              <option value="Mo">Mo</option>
                              <option value="Ma">Ma</option>
                              <option value="Me">Me</option>
                              <option value="Ju">Ju</option>
                              <option value="Ve">Ve</option>
                              <option value="Sa">Sa</option>
                              <option value="Ra">Ra</option>
                              <option value="Ke">Ke</option>
                            </select>
                            <span class="input-group-text">IS IN HOUSE NUMBER</span>
                            <select v-model="house" class="col-2" style="text-align: center">
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </select>
                            <button id="button-addon2" class="btn btn-primary" type="button" @click="loadCondition">
                              Load
                            </button>
                            <button id="button-addon2" class="btn btn-success" type="button" @click="saveCondition">
                              {{ saveOrUpdate }}
                            </button>
                          </div>


                          <editor v-model="editorData2" :init="tinyMceInit"/>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  تفسیر چارت خورشید
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <div class="input-group" style="direction: ltr">
                    <select v-model="selected_sun_sign" class="form-control w-100">
                      <option value="1">Aries - 1</option>
                      <option value="2">Taurus - 2</option>
                      <option value="3">Gemini - 3</option>
                      <option value="4">Cancer - 4</option>
                      <option value="5">Leo - 5</option>
                      <option value="6">Virgo - 6</option>
                      <option value="7">Libra - 7</option>
                      <option value="8">Scorpio - 8</option>
                      <option value="9">Saggitarius - 9</option>
                      <option value="10">Capricorn - 10</option>
                      <option value="11">Aquarius - 11</option>
                      <option value="12">Pisces - 12</option>
                    </select>
                    <button type="button" class="btn btn-outline-primary" @click="loadSunSign">
                      Load configuration
                    </button>
                  </div>

                  <div v-if="sun_sign_no" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b>Sun Chart - Sign no: {{ selected_sun_sign }} </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>


                          <editor v-model="sun_sign_body" :init="tinyMceInit"/>

                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveSunSign">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  تفسیر چارت ماه
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <div class="input-group" style="direction: ltr">
                    <select v-model="selected_moon_sign" class="form-control w-100">
                      <option value="1">Aries - 1</option>
                      <option value="2">Taurus - 2</option>
                      <option value="3">Gemini - 3</option>
                      <option value="4">Cancer - 4</option>
                      <option value="5">Leo - 5</option>
                      <option value="6">Virgo - 6</option>
                      <option value="7">Libra - 7</option>
                      <option value="8">Scorpio - 8</option>
                      <option value="9">Saggitarius - 9</option>
                      <option value="10">Capricorn - 10</option>
                      <option value="11">Aquarius - 11</option>
                      <option value="12">Pisces - 12</option>
                    </select>
                    <button type="button" class="btn btn-outline-primary" @click="loadMoonSign">
                      Load configuration
                    </button>
                  </div>
                  <div v-if="moon_sign_no" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b>Moon Chart - Sign no: {{ selected_moon_sign }} </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>


                          <editor v-model="moon_sign_body" :init="tinyMceInit"/>


                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveMoonSign">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  تفسیر ناکشاترای اسندانت
                </button>
              </h2>
              <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <!-- <p>Select Nakshatra of Ascendant</p> -->
                  <div class="input-group" style="direction: ltr">
                    <select v-model="selected_nak_asc_no" class="form-control w-100">
                      <option value="1">1 - Ashwini</option>
                      <option value="2">2 - Bharani</option>
                      <option value="3">3 - Krittika</option>
                      <option value="4">4 - Rohini</option>
                      <option value="5">5 - Mrigashirsha</option>
                      <option value="6">6 - Ardra</option>
                      <option value="7">7 - Punarvasu</option>
                      <option value="8">8 - Pushya</option>
                      <option value="9">9 - Ashlesha</option>
                      <option value="10">10 - Magha</option>
                      <option value="11">11 - Purva Phalguni</option>
                      <option value="12">12 - Uttara Phalguni</option>
                      <option value="13">13 - Hasta</option>
                      <option value="14">14 - Chitra</option>
                      <option value="15">15 - Swati</option>
                      <option value="16">16 - Vishakha</option>
                      <option value="17">17 - Anuradha</option>
                      <option value="18">18 - Jyeshtha</option>
                      <option value="19">19 - Mula</option>
                      <option value="20">20 - Purva Ashadha</option>
                      <option value="21">21 - Uttara Ashadha</option>
                      <option value="22">22 - Shravana</option>
                      <option value="23">23 - Dhanishta</option>
                      <option value="24">24 - Shatabhisha</option>
                      <option value="25">25 - Purva Bhadrapada</option>
                      <option value="26">26 - Uttara Bhadrapada</option>
                      <option value="27">27 - Revati</option>
                    </select>

                    <button type="button" class="btn btn-outline-primary" @click="loadNakAsc">
                      Load configuration
                    </button>
                  </div>

                  <div v-if="nak_asc_no" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b>Nakshatra of Ascendant, Nakshatra No:
                              {{ selected_nak_asc_no }}
                            </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>


                          <editor v-model="nak_asc_body" :init="tinyMceInit"/>


                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveNakAsc">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                  تفسیر آتما کاراکا
                </button>
              </h2>
              <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <!-- <p>Select planet of Atmakaraka</p> -->
                  <div class="input-group" style="direction: ltr">
                    <select v-model="selected_ak_planet" class="col-2" style="text-align: center">
                      <option value="Su">Su</option>
                      <option value="Mo">Mo</option>
                      <option value="Ma">Ma</option>
                      <option value="Me">Me</option>
                      <option value="Ju">Ju</option>
                      <option value="Ve">Ve</option>
                      <option value="Sa">Sa</option>
                      <option value="Ra">Ra</option>
                      <option value="Ke">Ke</option>
                    </select>
                    <button type="button" class="btn btn-outline-primary" @click="loadAK">
                      Load configuration
                    </button>
                  </div>

                  <div v-if="ak_planet" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b>If Atma is {{ ak_planet }} then show this description </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>


                          <editor v-model="ak_planet_body" :init="tinyMceInit"/>


                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveAKDetail">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                  تفسیر سیاره آتما در نشان‌ها
                </button>
              </h2>
              <div id="collapseEight" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">

                  <div class="input-group" style="direction: ltr">
                    <select v-model="selected_akd_planet" class="col-4" style="text-align: center">
                      <option value="Su">Su</option>
                      <option value="Mo">Mo</option>
                      <option value="Ma">Ma</option>
                      <option value="Me">Me</option>
                      <option value="Ju">Ju</option>
                      <option value="Ve">Ve</option>
                      <option value="Sa">Sa</option>
                      <option value="Ra">Ra</option>
                    </select>
                    <span id="basic-addon2" class="input-group-text">IN SIGN</span>

                    <select v-model="selected_akd_sign" class="form-control col-4">
                      <option value="1">Aries - 1</option>
                      <option value="2">Taurus - 2</option>
                      <option value="3">Gemini - 3</option>
                      <option value="4">Cancer - 4</option>
                      <option value="5">Leo - 5</option>
                      <option value="6">Virgo - 6</option>
                      <option value="7">Libra - 7</option>
                      <option value="8">Scorpio - 8</option>
                      <option value="9">Saggitarius - 9</option>
                      <option value="10">Capricorn - 10</option>
                      <option value="11">Aquarius - 11</option>
                      <option value="12">Pisces - 12</option>
                    </select>
                    <button type="button" class="btn btn-primary" @click="loadAKD">
                      Load configuration
                    </button>
                    <button v-if="loaded_akd_planet" type="button" class="btn btn-success" @click="saveAKD">
                      Save
                    </button>
                  </div>

                  <div v-if="loaded_akd_planet" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b>Atma is {{ loaded_akd_planet }} and it's in sign
                              {{ loaded_akd_sign }}:
                            </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>


                          <editor v-model="loaded_akd_planet_body" :init="tinyMceInit"/>

                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveAKD">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                  تفسیر چاراکاراکا
                </button>
              </h2>
              <div id="collapseTen" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <div style="padding: 20px; font-weight: bold; direction: ltr;">
                    <ul>
                      <li>
                        AmatyaKaraka (AmK)
                      </li>
                      <li>
                        BhratriKaraka (BK)
                      </li>
                      <li>
                        MatriKaraka (MK)
                      </li>
                      <li>
                        PitriKaraka (PiK)
                      </li>
                      <li>
                        GnatiKaraka (GK)
                      </li>
                      <li>
                        DaraKaraka (DK)
                      </li>
                    </ul>
                  </div>

                  <div class="input-group" style="direction: ltr">
                    <select v-model="selected_karaka_planet" class="col-2" style="text-align: center">
                      <option value="Su">Su</option>
                      <option value="Mo">Mo</option>
                      <option value="Ma">Ma</option>
                      <option value="Me">Me</option>
                      <option value="Ju">Ju</option>
                      <option value="Ve">Ve</option>
                      <option value="Sa">Sa</option>
                    </select>
                    <span id="basic-addon2" class="input-group-text">IS </span>
                    <select v-model="selected_karaka_type" class="form-control col-1">
                      <option value="AmK" selected>AmK</option>
                      <option value="BK">BK</option>
                      <option value="MK">MK</option>
                      <option value="PiK">PiK</option>
                      <option value="GK">GK</option>
                      <option value="DK">DK</option>
                    </select>
                    <span id="basic-addon2" class="input-group-text">AND SIGN</span>
                    <select v-model="selected_karaka_sign" class="form-control col-4">
                      <option value="1">Aries - 1</option>
                      <option value="2">Taurus - 2</option>
                      <option value="3">Gemini - 3</option>
                      <option value="4">Cancer - 4</option>
                      <option value="5">Leo - 5</option>
                      <option value="6">Virgo - 6</option>
                      <option value="7">Libra - 7</option>
                      <option value="8">Scorpio - 8</option>
                      <option value="9">Saggitarius - 9</option>
                      <option value="10">Capricorn - 10</option>
                      <option value="11">Aquarius - 11</option>
                      <option value="12">Pisces - 12</option>
                    </select>
                    <button type="button" class="btn btn-primary" @click="loadKarakaDetail">
                      Load configuration
                    </button>
                    <button v-if="loaded_karaka_planet" type="button" class="btn btn-success" @click="saveKarakaDetail">
                      Save
                    </button>
                  </div>

                  <div v-if="loaded_karaka_planet" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b>Charakaraka planet is {{ loaded_karaka_planet }},
                              <strong>({{ loaded_karaka_type }})</strong> and sign
                              {{ loaded_karaka_sign }}
                            </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>

                          <editor v-model="loaded_karaka_body" :init="tinyMceInit"/>


                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveKarakaDetail">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseThirteen" aria-expanded="false" aria-controls="collapseThirteen">
                  تفسیر محور Ra/Ke
                </button>
              </h2>
              <div id="collapseThirteen" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <!-- <p>[report_axis_ra_ke]</p> -->
                  <div class="input-group" style="direction: ltr">
                    If Rahu was in Sign: &nbsp;
                    <select v-model="selected_rake_sign" class="form-control col-4">
                      <option value="1">Aries - 1</option>
                      <option value="2">Taurus - 2</option>
                      <option value="3">Gemini - 3</option>
                      <option value="4">Cancer - 4</option>
                      <option value="5">Leo - 5</option>
                      <option value="6">Virgo - 6</option>
                      <option value="7">Libra - 7</option>
                      <option value="8">Scorpio - 8</option>
                      <option value="9">Saggitarius - 9</option>
                      <option value="10">Capricorn - 10</option>
                      <option value="11">Aquarius - 11</option>
                      <option value="12">Pisces - 12</option>
                    </select>
                    <button type="button" class="btn btn-primary" @click="loadRAKESign">
                      Load configuration
                    </button>
                    <button v-if="loaded_rake_sign" type="button" class="btn btn-success" @click="saveRAKEDetail">
                      Save
                    </button>
                  </div>

                  <div v-if="loaded_rake_sign" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b> Current position of moon in sign {{ loaded_rake_sign }} </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>



                          <editor v-model="loaded_rake_body" :init="tinyMceInit"/>


                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveRAKEDetail">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                  تفسیر ماهاداشا
                </button>
              </h2>
              <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordionExample">

                <div class="accordion-body">
                  <!-- <p>Select planet of Mahadasha</p> -->
                  <div class="input-group" style="direction: ltr">
                    <select v-model="selected_md_planet" class="col-2" style="text-align: center">
                      <option value="Su">Su</option>
                      <option value="Mo">Mo</option>
                      <option value="Ma">Ma</option>
                      <option value="Me">Me</option>
                      <option value="Ju">Ju</option>
                      <option value="Ve">Ve</option>
                      <option value="Sa">Sa</option>
                      <option value="Ra">Ra</option>
                      <option value="Ke">Ke</option>
                    </select>
                    <button type="button" class="btn btn-outline-primary" @click="loadMahadasha">
                      Load configuration
                    </button>
                  </div>

                  <div v-if="md_planet" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b>If Active Mahadasha is {{ md_planet }} then show this
                              description
                            </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>


                          <editor v-model="md_planet_body" :init="tinyMceInit"/>


                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveMahaDasha">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                  تفسیر سیاره در ناکشاترا
                </button>
              </h2>
              <div id="collapseSeven" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <div class="input-group" style="direction: ltr">
                    <select v-model="selected_nak_planet" class="col-4" style="text-align: center">
                      <option value="Su">Su</option>
                      <option value="Mo">Mo</option>
                      <option value="Ma">Ma</option>
                      <option value="Me">Me</option>
                      <option value="Ju">Ju</option>
                      <option value="Ve">Ve</option>
                      <option value="Sa">Sa</option>
                      <option value="Ra">Ra</option>
                      <option value="Ke">Ke</option>
                    </select>
                    <span id="basic-addon2" class="input-group-text">IN</span>

                    <select v-model="selected_planet_nak_no" class="form-control col-4">
                      <option value="1">1 - Ashwini</option>
                      <option value="2">2 - Bharani</option>
                      <option value="3">3 - Krittika</option>
                      <option value="4">4 - Rohini</option>
                      <option value="5">5 - Mrigashirsha</option>
                      <option value="6">6 - Ardra</option>
                      <option value="7">7 - Punarvasu</option>
                      <option value="8">8 - Pushya</option>
                      <option value="9">9 - Ashlesha</option>
                      <option value="10">10 - Magha</option>
                      <option value="11">11 - Purva Phalguni</option>
                      <option value="12">12 - Uttara Phalguni</option>
                      <option value="13">13 - Hasta</option>
                      <option value="14">14 - Chitra</option>
                      <option value="15">15 - Swati</option>
                      <option value="16">16 - Vishakha</option>
                      <option value="17">17 - Anuradha</option>
                      <option value="18">18 - Jyeshtha</option>
                      <option value="19">19 - Mula</option>
                      <option value="20">20 - Purva Ashadha</option>
                      <option value="21">21 - Uttara Ashadha</option>
                      <option value="22">22 - Shravana</option>
                      <option value="23">23 - Dhanishta</option>
                      <option value="24">24 - Shatabhisha</option>
                      <option value="25">25 - Purva Bhadrapada</option>
                      <option value="26">26 - Uttara Bhadrapada</option>
                      <option value="27">27 - Revati</option>
                    </select>
                    <button type="button" class="btn btn-primary" @click="loadNakPlanet">
                      Load configuration
                    </button>
                    <button v-if="loaded_planet_nak_no" type="button" class="btn btn-success" @click="saveNakPlanet">
                      Save
                    </button>
                  </div>

                  <div v-if="loaded_planet_nak_no" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b>If {{ loaded_planet_of_nak }} is in
                              {{ loaded_planet_nak_no }} then show this description
                            </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>

                          <editor v-model="loaded_planet_nak_body" :init="tinyMceInit"/>


                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveNakPlanet">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                  تفسیر وضعیت اکنون ماه در نشان
                </button>
              </h2>
              <div id="collapseEleven" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <!-- <p>[report_moon_now]</p> -->
                  <div class="input-group" style="direction: ltr">
                    <select v-model="selected_nm_sign" class="form-control col-4">
                      <option value="1">Aries - 1</option>
                      <option value="2">Taurus - 2</option>
                      <option value="3">Gemini - 3</option>
                      <option value="4">Cancer - 4</option>
                      <option value="5">Leo - 5</option>
                      <option value="6">Virgo - 6</option>
                      <option value="7">Libra - 7</option>
                      <option value="8">Scorpio - 8</option>
                      <option value="9">Saggitarius - 9</option>
                      <option value="10">Capricorn - 10</option>
                      <option value="11">Aquarius - 11</option>
                      <option value="12">Pisces - 12</option>
                    </select>
                    <button type="button" class="btn btn-primary" @click="loadNMSign">
                      Load configuration
                    </button>
                    <button v-if="loaded_nm_sign" type="button" class="btn btn-success" @click="saveNMSignDetail">
                      Save
                    </button>
                  </div>

                  <div v-if="loaded_nm_sign" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b> Current position of moon in sign {{ loaded_nm_sign }} </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>


                          <editor v-model="loaded_nm_body" :init="tinyMceInit"/>


                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveNMSignDetail">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseTwelve" aria-expanded="false" aria-controls="collapseTwelve">
                  تفسیر وضعیت اکنون ماه در ناکشاترا
                </button>
              </h2>
              <div id="collapseTwelve" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <p>[report_moon_now_nak]</p>
                  <div class="input-group" style="direction: ltr">
                    <select v-model="selected_nmk" class="form-control col-4">
                      <option value="1">Ashwini</option>
                      <option value="2">Bharani</option>
                      <option value="3">Krittika</option>
                      <option value="4">Rohini</option>
                      <option value="5">Mrigashirsha</option>
                      <option value="6">Ardra</option>
                      <option value="7">Punarvasu</option>
                      <option value="8">Pushya</option>
                      <option value="9">Ashlesha</option>
                      <option value="10">Magha</option>
                      <option value="11">Poorva Phalguni</option>
                      <option value="12">Uttara Phalguni</option>
                      <option value="13">Hasta</option>
                      <option value="14">Chitra</option>
                      <option value="15">Swati</option>
                      <option value="16">Vishakha</option>
                      <option value="17">Anuradha</option>
                      <option value="18">Jyeshtha</option>
                      <option value="19">Moola</option>
                      <option value="20">Purva Ashadha</option>
                      <option value="21">Uttara Ashadha</option>
                      <option value="22">Shravana</option>
                      <option value="23">Dhanishta</option>
                      <option value="24">Shatabhisha</option>
                      <option value="25">Purva Bhadrapada</option>
                      <option value="26">Uttara Bhadrapada</option>
                      <option value="27">Revati</option>
                      <!-- <option value="28">Abhijit</option> -->
                    </select>
                    <button type="button" class="btn btn-primary" @click="loadNMNak">
                      Load configuration
                    </button>
                    <button v-if="loaded_nmk" type="button" class="btn btn-success" @click="saveNMNakDetail">
                      Save
                    </button>
                  </div>

                  <div v-if="loaded_nmk" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b> Current position of moon in nakshatra {{ loaded_nmk }} </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>

                          <editor v-model="loaded_nmk_body" :init="tinyMceInit"/>


                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveNMNakDetail">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#premiumVoice" aria-expanded="false" aria-controls="premiumVoice">
                  تفسیر اسندانت در نشان در صفحه پیش‌سفارش
                </button>
              </h2>
              <div id="premiumVoice" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <form @submit.prevent="saveSettings_premium_voices">
                    <div v-for="(value, key) in premiumVoices" :key="key" class="form-group">
                      <label :for="key">{{ key }} mp3 url</label>
                      <input type="text" class="form-control mb-3" :id="key" v-model="premiumVoices[key]">
                    </div>
                    <button type="submit" class="btn btn-primary">ذخیره اطلاعات</button>
                  </form>
                </div>
              </div>
            </div>







            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseٰWizardTexts" aria-expanded="false" aria-controls="collapseٰWizardTexts">
                  متون ثابت ویزارد
                </button>
              </h2>
              <div id="collapseٰWizardTexts" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <form @submit.prevent="saveSettings_birth_hints">
                    <div v-for="(value, key) in wizardSteps" :key="key" class="form-group">
                      <h5>متن مرحله {{ key }}</h5>

                      <editor v-model="wizardSteps" :init="tinyMceInit"/>

                    </div>
                    <button type="submit" class="btn btn-primary">ذخیره اطلاعات</button>
                  </form>
                </div>
              </div>
            </div>
          </div> <!-- end of Premium Chart -->

          <div style="padding: 10px; background-color: #F4E8FF; border-radius: 15px; margin-bottom: 15px;">
            <!-- start of Premium Chart -->
            <h4 style="width: 100%; text-align: right; color: #000; padding: 10px; text-shadow: 1px 0px 0px #fff;">
              تنظیمات تفسیر پرمیوم داشا
            </h4>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseTwenyth" aria-expanded="true" aria-controls="collapseTwenyth">
                  تفسیر اسندانت
                </button>
              </h2>
              <div id="collapseTwenyth" class="accordion-collapse collapse hide" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <div class="container w-100 p-3 bg-light rounded">
                    <!-- <p>Load configuration of gc10co risgins and their planets conditions</p> -->
                    <div class="input-group" style="direction: ltr">
                      <select v-model="gc10_selected_sign" class="form-control w-100">
                        <option value="1">Aries - 1</option>
                        <option value="2">Taurus - 2</option>
                        <option value="3">Gemini - 3</option>
                        <option value="4">Cancer - 4</option>
                        <option value="5">Leo - 5</option>
                        <option value="6">Virgo - 6</option>
                        <option value="7">Libra - 7</option>
                        <option value="8">Scorpio - 8</option>
                        <option value="9">Saggitarius - 9</option>
                        <option value="10">Capricorn - 10</option>
                        <option value="11">Aquarius - 11</option>
                        <option value="12">Pisces - 12</option>
                      </select>
                      <button type="button" class="btn btn-outline-primary" @click="gc10LoadSign">
                        Load configuration
                      </button>
                    </div>
                  </div>

                  <div class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b> Sign: {{ gc10_selected_sign_screen }} </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Sign description</b>
                          </h4>


                          <editor v-model="gc10Editor" :init="tinyMceInit"/>


                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" @click="saveGc10Sign" type="button">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                  تفسیر داشای فعال برای سیاره در نشان و خانه
                </button>
              </h2>
              <div id="collapseNine" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">

                  <div class="input-group" style="direction: ltr">
                    <span id="basic-addon2" class="input-group-text">PLANET</span>
                    <select v-model="selected_dasha_planet" class="col-1" style="text-align: center">
                      <option value="Su">Su</option>
                      <option value="Mo">Mo</option>
                      <option value="Ma">Ma</option>
                      <option value="Me">Me</option>
                      <option value="Ju">Ju</option>
                      <option value="Ve">Ve</option>
                      <option value="Sa">Sa</option>
                      <option value="Ra">Ra</option>
                      <option value="Ke">Ke</option>
                    </select>
                    <span id="basic-addon2" class="input-group-text">IN HOUSE</span>
                    <select v-model="selected_dasha_house" class="form-control col-1">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    <span id="basic-addon2" class="input-group-text">AND SIGN</span>
                    <select v-model="selected_dasha_sign" class="form-control col-4">
                      <option value="1">Aries - 1</option>
                      <option value="2">Taurus - 2</option>
                      <option value="3">Gemini - 3</option>
                      <option value="4">Cancer - 4</option>
                      <option value="5">Leo - 5</option>
                      <option value="6">Virgo - 6</option>
                      <option value="7">Libra - 7</option>
                      <option value="8">Scorpio - 8</option>
                      <option value="9">Saggitarius - 9</option>
                      <option value="10">Capricorn - 10</option>
                      <option value="11">Aquarius - 11</option>
                      <option value="12">Pisces - 12</option>
                    </select>
                    <button type="button" class="btn btn-primary" @click="loadDashaDetail">
                      Load configuration
                    </button>
                    <button v-if="loaded_dasha_planet" type="button" class="btn btn-success" @click="saveDashaDetail">
                      Save
                    </button>
                  </div>

                  <div v-if="loaded_dasha_planet" class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12">
                        <div class="w-100 p-3 bg-light rounded mb-3">
                          <h4 style="width: 100%; text-align: center">
                            <b>Dasha is {{ loaded_dasha_planet }}, in house
                              {{ loaded_dasha_house }} and sign {{ loaded_dasha_sign }}
                            </b>
                          </h4>
                        </div>
                        <div class="w-100 p-3 bg-light rounded">
                          <h4 class="p-2">
                            <b>Description</b>
                          </h4>


                          <editor v-model="loaded_dasha_body" :init="tinyMceInit"/>



                          <p class="w-100 p-4 text-center">
                            <button class="btn btn-success" type="button" @click="saveDashaDetail">
                              Save description
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseٰVoices" aria-expanded="false" aria-controls="collapseٰVoices">
                      تنظیمات ویس های مرحله دوم
                    </button>
                  </h2>
                  <div id="collapseٰVoices" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <form @submit.prevent="saveSettings_momentum_voices">
                        <div v-for="(value, key) in momentumVoices" :key="key" class="form-group">
                          <label :for="key">{{ key }}</label>
                          <input type="text" class="form-control" :id="key" v-model="momentumVoices[key]">
                        </div>
                        <button type="submit" class="btn btn-primary">ذخیره اطلاعات</button>
                      </form>
                    </div>
                  </div>
                </div>




            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseٰVoices2" aria-expanded="false" aria-controls="collapseٰVoices2">
                  تنظیمات ویس های مرحله سوم
                </button>
              </h2>
              <div id="collapseٰVoices2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <form @submit.prevent="saveSettings_momentum_voices2">
                    <div v-for="(value, key) in momentumVoices2" :key="key" class="form-group">
                      <label :for="key">{{ key }}</label>
                      <input type="text" class="form-control" :id="key" v-model="momentumVoices2[key]">
                    </div>
                    <button type="submit" class="btn btn-primary">ذخیره اطلاعات</button>
                  </form>
                </div>
              </div>
            </div>


          </div>

        </div>



        <hr><br>
        <LoveAdmin :tinyMceInit="tinyMceInit"/>
        <hr><br>
        <HealthAdmin :tinyMceInit="tinyMceInit"/>
        <hr><br>
        <WealthAdmin :tinyMceInit="tinyMceInit"/>
        <hr><br>
        <CareerAdmin :tinyMceInit="tinyMceInit"/>
        <hr><br>



        <div id="accordionExampleTalent" class="accordion p-2 border-rounded bg-white" style="border-radius: 15px;">
          <div style="padding: 10px; background-color: #ADD8E6; border-radius: 15px; margin-bottom: 15px;">
            <!-- start of Premium Chart -->
            <h4 style="width: 100%; text-align: right; color: #000; padding: 10px; text-shadow: 1px 0px 0px #fff;">
              تنظیمات تفسیر تلنت
            </h4>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapsetl1"
                        aria-expanded="true" aria-controls="collapsetl1">
                  تفسیر تلنت
                </button>
              </h2>
              <div id="collapsetl1" class="accordion-collapse collapse hide" data-bs-parent="#accordionExampleTalent">
                <div class="accordion-body">
                  <div class="container w-100 p-3 bg-light rounded">
                    <!-- <p>Load configuration of risgins and their planets conditions</p> -->

                  </div>

                  <div  class="row mt-4">
                    <div class="container w-100 p-3 bg-light rounded">
                      <div class="col-12 p-3" style="text-align: center; font-size: 16px">
                        <div class="w-100 bg-light p-3 mb-4">
                          <h4 class="w-100 mt-4 mb-2" style="text-align: left">
                            {{ CONDITION_TITLE }}
                          </h4>
                          <div class="input-group mb-3" style="direction: ltr">
                            <span class="input-group-text">IF PLANET</span>
                            <select v-model="planet" class="col-2" style="text-align: center">
                              <option value="Su">Su</option>
                              <option value="Mo">Mo</option>
                              <option value="Ma">Ma</option>
                              <option value="Me">Me</option>
                              <option value="Ju">Ju</option>
                              <option value="Ve">Ve</option>
                              <option value="Sa">Sa</option>
                              <option value="Ra">Ra</option>
                              <option value="Ke">Ke</option>
                            </select>
                            <span class="input-group-text">IN NAK</span>
                            <select v-model="selected_planet_nak_no" class="form-control col-4">
                              <option value="1">1 - Ashwini</option>
                              <option value="2">2 - Bharani</option>
                              <option value="3">3 - Krittika</option>
                              <option value="4">4 - Rohini</option>
                              <option value="5">5 - Mrigashirsha</option>
                              <option value="6">6 - Ardra</option>
                              <option value="7">7 - Punarvasu</option>
                              <option value="8">8 - Pushya</option>
                              <option value="9">9 - Ashlesha</option>
                              <option value="10">10 - Magha</option>
                              <option value="11">11 - Purva Phalguni</option>
                              <option value="12">12 - Uttara Phalguni</option>
                              <option value="13">13 - Hasta</option>
                              <option value="14">14 - Chitra</option>
                              <option value="15">15 - Swati</option>
                              <option value="16">16 - Vishakha</option>
                              <option value="17">17 - Anuradha</option>
                              <option value="18">18 - Jyeshtha</option>
                              <option value="19">19 - Mula</option>
                              <option value="20">20 - Purva Ashadha</option>
                              <option value="21">21 - Uttara Ashadha</option>
                              <option value="22">22 - Shravana</option>
                              <option value="23">23 - Dhanishta</option>
                              <option value="24">24 - Shatabhisha</option>
                              <option value="25">25 - Purva Bhadrapada</option>
                              <option value="26">26 - Uttara Bhadrapada</option>
                              <option value="27">27 - Revati</option>
                            </select>
                            <span class="input-group-text">IS IN HOUSE NUMBER</span>
                            <select v-model="houseTalent" class="col-2" style="text-align: center">
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                            </select>
                            <button id="button-addon2" class="btn btn-primary" type="button" @click="loadConditionTalent">
                              Load
                            </button>
                            <button id="button-addon2" class="btn btn-success" type="button" @click="saveConditionTalent">
                              {{ saveOrUpdate }}
                            </button>
                          </div>

                          <div class="mb-3 talent_titles">
                            <div class="d-flex flex-column gap-3 align-items-start w-100">
                              <label for="pre_title">عنوان مرحله پیش از خرید</label>
                              <input placeholder="عنوان مرحله پیش از خرید" class="w-100" type="text" name="pre_title" id="pre_title" v-model="pre_title">
                            </div>
                            <div class="d-flex flex-column gap-3 align-items-start w-100">
                              <label for="pro_title">عنوان مرحله پس از خرید</label>
                              <input placeholder="عنوان مرحله پس از خرید" class="w-100" type="text" name="pro_title" id="pro_title" v-model="pro_title">
                            </div>
                            <div class="d-flex flex-column gap-3 align-items-start w-100">
                              <label for="hora_order">عدد اولویت (اوردر)</label>
                              <select class="w-100" name="hora_order" id="hora_order" v-model="hora_order">
                                <option v-for="number in 5" :key="number" :value="number">{{ number }}</option>
                              </select>
                            </div>
                            <div>
                              <input type="checkbox"
                                     id="talent_inactive"
                                     v-model="talentInactive"
                                     :value="talentInactive"
                                     :checked="talentInactive"
                              >
                              <label for="talent_inactive">غیر فعال کردن</label>
                            </div>
                          </div>

                          <editor v-model="editorData2" :init="tinyMceInit"/>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>







            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#premiumVoice_pre" aria-expanded="false" aria-controls="premiumVoice_pre">
                 تنظیمات ویس مرحله پیش سفارش
                </button>
              </h2>
              <div id="premiumVoice_pre" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <form @submit.prevent="saveSettings_talent_voices">
                    <div v-for="(value, key) in talentVoices1" :key="key" class="form-group">
                      <label :for="key">{{ key }} mp3 url</label>
                      <input type="text" class="form-control mb-3" :id="key" v-model="talentVoices1[key]">
                    </div>
                    <button type="submit" class="btn btn-primary">ذخیره اطلاعات</button>
                  </form>
                </div>
              </div>
            </div>


            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#premiumVoice_pro" aria-expanded="false" aria-controls="premiumVoice_pro">
                 تنظیمات ویس مرحله چارت
                </button>
              </h2>
              <div id="premiumVoice_pro" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <form @submit.prevent="saveSettings_talent_voices2">
                    <div v-for="(value, key) in talentVoices2" :key="key" class="form-group">
                      <label :for="key">{{ key }} mp3 url</label>
                      <input type="text" class="form-control mb-3" :id="key" v-model="talentVoices2[key]">
                    </div>
                    <button type="submit" class="btn btn-primary">ذخیره اطلاعات</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import HoraLogo from '../components/HoraLogo.vue'
import Dashboard from './Dashboard.vue'
import AdminService from './admin-service'
import LoveAdmin from "./components/Love/LoveAdmin.vue";
// TinyMCE
import 'tinymce/tinymce'
import 'tinymce/icons/default/icons'
import 'tinymce/themes/silver/theme'
import 'tinymce/models/dom/model'
import 'tinymce/skins/ui/oxide/skin.css'
import 'tinymce/skins/ui/oxide/content.css';

// TinyMCE plugins
import 'tinymce/plugins/lists/plugin'
import 'tinymce/plugins/link/plugin'
import 'tinymce/plugins/image/plugin'
import 'tinymce/plugins/media/plugin'
import 'tinymce/plugins/table/plugin'
import 'tinymce/plugins/code/plugin'
import 'tinymce/plugins/help/plugin'
import 'tinymce/plugins/wordcount/plugin'

import Editor from '@tinymce/tinymce-vue'
import HealthAdmin from "./components/Health/HealthAdmin.vue";
import WealthAdmin from "./components/Wealth/WealthAdmin.vue";
import CareerAdmin from "./components/Career/CareerAdmin.vue";


export default {
  name: 'AdminView',
  components: {
    CareerAdmin,
    WealthAdmin,
    HealthAdmin,
    LoveAdmin,
    Dashboard,
    Editor,
    HoraLogo,
    AdminService
  },
  data() {
    return {

      tinyMceInit: {
        license_key: 'gpl',
        plugins: 'lists link image media table code help wordcount paste',  // Added 'paste' plugin
        toolbar: 'undo redo | formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media',
        image_advtab: true,
        image_title: true,
        directionality: 'rtl',
        automatic_uploads: true,
        file_picker_types: 'image media',
        file_picker_callback: function (cb, value, meta) {
          var input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*,video/*,audio/*');  // Accept images, videos, and audio files

          input.onchange = function () {
            var file = this.files[0];
            var formData = new FormData();
            formData.append('file', file);  // Append the file
            formData.append('action', 'upload-attachment');  // Action for the media upload
            var username = 'morisfa';
            var appPassword = 'aQdw UNc4 qc02 N7HT P9Hd xTAq'; // Ensure there are no spaces in your actual password

            var element = document.getElementById('admin-view');
            var nonceValue = element.getAttribute('data-none');

            fetch('/wp-json/wp/v2/media', {
              method: 'POST',
              body: formData,
              credentials: 'include',
              headers: {
                'Authorization': 'Basic ' + btoa(username + ':' + appPassword),
                'X-WP-Nonce' :  nonceValue
              }
            })
              .then(response => response.json())
              .then(data => {
                if (data && data.source_url) {
                  // Use the URL of the uploaded file
                  cb(data.source_url, { title: file.name });
                } else {
                  console.error('Failed to upload file:', data.message);
                }
              })
              .catch(error => {
                console.error('Error uploading file:', error);
              });
          };

          input.click();
        },
        skin: false,
        branding: false,
        content_css: false,
        paste_auto_cleanup_on_paste: true,
        paste_remove_styles: true,
        paste_strip_class_attributes: 'all',
        paste_merge_formats: false,
      },

      premiumVoices: {
        Aries : '',
        Taurus : '',
        Gemini : '',
        Cancer : '',
        Leo : '',
        Virgo : '',
        Libra : '',
        Scorpio : '',
        Saggitarius : '',
        Capricorn : '',
        Aquarius : '',
        Pisces : ''
      },

      talentVoices1: {
        Aries : '',
        Taurus : '',
        Gemini : '',
        Cancer : '',
        Leo : '',
        Virgo : '',
        Libra : '',
        Scorpio : '',
        Saggitarius : '',
        Capricorn : '',
        Aquarius : '',
        Pisces : ''
      },

      talentVoices2: {
        Aries : '',
        Taurus : '',
        Gemini : '',
        Cancer : '',
        Leo : '',
        Virgo : '',
        Libra : '',
        Scorpio : '',
        Saggitarius : '',
        Capricorn : '',
        Aquarius : '',
        Pisces : ''
      },

      momentumVoices: {
        Su: '',
        Mo: '',
        Ma: '',
        Me: '',
        Ju: '',
        Ve: '',
        Sa: '',
        Ra: '',
        Ke: ''
      },
      momentumVoices2: {
        Su: '',
        Mo: '',
        Ma: '',
        Me: '',
        Ju: '',
        Ve: '',
        Sa: '',
        Ra: '',
        Ke: ''
      },

      talentVoices: {
        Su: '',
        Mo: '',
        Ma: '',
        Me: '',
        Ju: '',
        Ve: '',
        Sa: '',
        Ra: '',
        Ke: ''
      },


      wizardSteps: {
        1: '',
        2: '',
        3: '',
        4: ''
      },

      gc10_sign_no: "",
      gc10_selected_sign: "",
      gc10_selected_sign_screen: "",
      gc10Editor: "",

      KRMRAKE_CONDITION_TITLE: 'Condition',
      karmic_ra_ke_asc: "",
      karmic_ra_ke_sign_no: "",
      karmic_ra_ke_house: "",
      karmicRAKEConditionEditor: "",
      bcpre_selected_sign: '',
      bcpre_sign: '',
      bcpreEditor: '',

      CONDITION_TITLE: 'New Condition',
      saveOrUpdate: 'Save',
      condition_id: '',
      conditions: [],
      sign_no: '',
      selected_sign: '',
      selected_sign_screen: '',

      nak_asc_no: '',
      selected_nak_asc_no: '',
      nak_asc_body: '',

      selected_nak_planet: '',
      selected_planet_nak_no: '',
      loaded_planet_nak_body: '',
      loaded_planet_nak_no: '',
      loaded_planet_of_nak: '',

      selected_karaka_planet: '',
      selected_karaka_type: '',
      selected_karaka_sign: '',
      loaded_karaka_planet: '',
      loaded_karaka_sign: '',
      loaded_karaka_type: '',
      loaded_karaka_body: '',

      sun_sign_no: '',
      selected_sun_sign: '',
      selected_sun_sign_screen: '',
      sun_sign_body: '',

      moon_sign_no: '',
      selected_moon_sign: '',
      selected_moon_sign_screen: '',
      moon_sign_body: '',

      selected_ak_planet: '',
      ak_planet: '',
      ak_planet_body: '',

      selected_akd_planet: '',
      selected_akd_sign: '',
      loaded_akd_sign: '',
      loaded_akd_planet: '',
      loaded_akd_planet_body: '',

      selected_nm_sign: '',
      loaded_nm_sign: '',
      loaded_nm_body: '',

      selected_nmk: '',
      loaded_nmk: '',
      loaded_nmk_body: '',

      selected_dasha_planet: '',
      selected_dasha_house: '',
      selected_dasha_sign: '',
      loaded_dasha_planet: '',
      loaded_dasha_house: '',
      loaded_dasha_sign: '',
      loaded_dasha_body: '',

      selected_md_planet: '',
      md_planet: '',
      md_planet_body: '',

      selected_rake_sign: '',
      loaded_rake_sign: '',
      loaded_rake_body: '',

      planet: '',
      house: '',
      houseTalent: '',
      loadData: '',
      editor: [],
      editorData: '',
      editorConfig: {
        toolbar: [
          'fontColor',
          'fontBackgroundColor',
          'bold',
          'italic',
          '|',
          'link',
          'bulletedList',
          'numberedList',
          'undo',
          'redo'
        ],
        language: {
          ui: 'en',
          content: 'ar'
        }
      },
      editor2: [],
      editorData2: '',
      pre_title: '',
      pro_title: '',
      hora_order: '',
      talentInactive: '',
      editorConfig2: {
        toolbar: ['bold', 'italic', '|', 'link', ''],
        language: {
          ui: 'en',
          content: 'ar'
        }
      }
    }
  },

  mounted: function() {
    this.loadSettings_momentum_voices();
    this.loadSettings_talent_voices();
    this.loadSettings_birth_hints();
    this.loadSettings_premium_voices();
  },

  methods: {

    loadSettings_momentum_voices: function() {
      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          action: 'get_momentum_voices',
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            this.momentumVoices = data.data;
          } else {
            console.error('اطلاعات دریافت نشد!!!!!!!');
          }
        });

      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          action: 'get_momentum_voices_final',
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            this.momentumVoices2 = data.data;
          } else {
            console.error('اطلاعات دریافت نشد!!!!!!!');
          }
        });
    },


    loadSettings_talent_voices: function() {
      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          action: 'get_talent_voices',
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            console.log("Tl Voice",data)
            this.talentVoices1 = data.data;
          } else {
            console.error('اطلاعات دریافت نشد!!!!!!!');
          }
        });

      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          action: 'get_talent_voices_final',
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            this.talentVoices2 = data.data;
          } else {
            console.error('اطلاعات دریافت نشد!!!!!!!');
          }
        });
    },

    saveSettings_momentum_voices: function() {
      const data = {
        action: 'save_momentum_voices',
        momentum_voices: JSON.stringify(this.momentumVoices)
      };

      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            alert('تنظیمات با موفقیت ذخیره شد');
          } else {
            alert('اطلاعات ذخیره نشد !!');
          }
        });
    },

    saveSettings_momentum_voices2: function() {
      const data = {
        action: 'save_momentum_voices_final',
        momentum_voices: JSON.stringify(this.momentumVoices2)
      };

      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            alert('تنظیمات با موفقیت ذخیره شد');
          } else {
            alert('اطلاعات ذخیره نشد !!');
          }
        });
    },

  saveSettings_talent_voices: function() {
      const data = {
        action: 'save_talent_voices',
        talent_voices: JSON.stringify(this.talentVoices1)
      };

      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            alert('تنظیمات با موفقیت ذخیره شد');
          } else {
            alert('اطلاعات ذخیره نشد !!');
          }
        });
    },

    saveSettings_talent_voices2: function() {
      const data = {
        action: 'save_talent_voices_final',
        talent_voices: JSON.stringify(this.talentVoices2)
      };

      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            alert('تنظیمات با موفقیت ذخیره شد');
          } else {
            alert('اطلاعات ذخیره نشد !!');
          }
        });
    },

    loadSettings_premium_voices: function() {
      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          action: 'get_premium_voices',
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            this.premiumVoices = data.data;
          } else {
            console.error('اطلاعات دریافت نشد!!!!!!!');
          }
        });
    },

    saveSettings_premium_voices: function() {
      const data = {
        action: 'save_premium_voices',
        premium_voices: JSON.stringify(this.premiumVoices)
      };

      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            alert('تنظیمات با موفقیت ذخیره شد');
          } else {
            alert('اطلاعات ذخیره نشد !!');
          }
        });
    },

    loadSettings_birth_hints: function() {
      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          action: 'get_birth_chart_hints',
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            this.wizardSteps = data.data;
          } else {
            console.error('اطلاعات دریافت نشد!!!!!!!');
          }
        });
    },

    saveSettings_birth_hints: function() {
      const data = {
        action: 'save_birth_chart_hints',
        birth_chart_hints: JSON.stringify(this.wizardSteps)
      };

      fetch("/wp-admin/admin-ajax.php", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(data)
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            alert('تنظیمات با موفقیت ذخیره شد');
          } else {
            alert('اطلاعات ذخیره نشد !!');
          }
        });
    },

    // saveBcpreSign
    saveRAKEDetail() {
      const request = {
        sign_no: this.selected_rake_sign,
        body: this.loaded_rake_body
      }
      AdminService.updateRAKEDetail(request).then((response) => {
        alert('Updated!')

      })
    },

    loadRAKESign() {
      AdminService.fetchRAKEDetail(this.selected_rake_sign).then((response) => {
        this.loaded_rake_sign = response['data']['sign_no']
        this.loaded_rake_body = response['data']['body']
      })
    },

    loadNMNak() {
      AdminService.fetchNowMoonNakDetail(this.selected_nmk).then((response) => {
        this.loaded_nmk = response['data']['nak_no']
        this.loaded_nmk_body = response['data']['body']
      })
    },

    saveNMNakDetail() {
      const request = {
        nak_no: this.selected_nmk,
        body: this.loaded_nmk_body
      }

      AdminService.updateNowMoonNakDetail(request).then((response) => {
        alert('Updated!')
      })
    },

    loadNMSign() {
      AdminService.fetchNowMoonDetail(this.selected_nm_sign).then((response) => {
        this.loaded_nm_sign = response['data']['sign_no']
        this.loaded_nm_body = response['data']['body']
      })
    },

    saveNMSignDetail() {
      const request = {
        sign_no: this.selected_nm_sign,
        body: this.loaded_nm_body
      }

      AdminService.updateNowMoonDetail(request).then((response) => {
        alert('Updated!')
      })
    },

    saveKarakaDetail() {
      const request = {
        planet: this.selected_karaka_planet,
        sign: this.selected_karaka_sign,
        karaka: this.selected_karaka_type,
        body: this.loaded_karaka_body
      }
      AdminService.updateKarakaDetail(request).then((response) => {
        alert('Updated!')
      })
    },

    loadKarakaDetail() {
      AdminService.fetchKarakaDetail(
        this.selected_karaka_planet,
        this.selected_karaka_sign,
        this.selected_karaka_type
      ).then((response) => {
        this.loaded_karaka_body = response['data']['body']
        this.loaded_karaka_planet = response['data']['planet']
        this.loaded_karaka_type = response['data']['karaka']
        this.loaded_karaka_sign = response['data']['sign']
      })
    },

    saveDashaDetail() {
      const request = {
        planet: this.selected_dasha_planet,
        sign: this.selected_dasha_sign,
        house: this.selected_dasha_house,
        body: this.loaded_dasha_body
      }

      AdminService.updateDashaDetail(request).then((response) => {
        alert('Updated!')
      })
    },

    loadDashaDetail() {
      AdminService.fetchDashaDetail(
        this.selected_dasha_planet,
        this.selected_dasha_sign,
        this.selected_dasha_house
      ).then((response) => {
        this.loaded_dasha_body = response['data']['body']
        this.loaded_dasha_planet = response['data']['planet']
        this.loaded_dasha_sign = response['data']['sign']
        this.loaded_dasha_house = response['data']['house']
      })
    },

    saveAKD() {
      const request = {
        planet: this.selected_akd_planet,
        sign: this.selected_akd_sign,
        body: this.loaded_akd_planet_body
      }
      AdminService.updateAKD(request).then((response) => {
        alert('Updated!')
      })
    },

    loadAKD() {
      AdminService.fetchAKD(this.selected_akd_planet, this.selected_akd_sign).then(
        (response) => {
          this.loaded_akd_planet_body = response['data']['body']
          this.loaded_akd_planet = response['data']['planet']
          this.loaded_akd_sign = response['data']['sign']
        }
      )
    },

    saveNakPlanet() {
      const request = {
        nak_no: this.selected_planet_nak_no,
        planet: this.selected_nak_planet,
        body: this.loaded_planet_nak_body
      }
      AdminService.updateNakPlanetCondition(request).then((response) => {
        alert('Updated!')
      })
    },

    loadNakPlanet() {
      AdminService.showNakPlanetCondition(
        this.selected_nak_planet,
        this.selected_planet_nak_no
      ).then((response) => {
        this.loaded_planet_nak_body = response['data']['body']
        this.loaded_planet_nak_no = response['data']['nak_no']
        this.loaded_planet_of_nak = response['data']['planet']
      })
    },

    newCondition() {
      this.condition_id = ''
      this.planet = ''
      this.house = ''
      this.editorData2 = ''
      this.saveOrUpdate = 'Save'
      this.CONDITION_TITLE = 'New Condition'
    },

    updateCondition() {
      const request = {
        condition_id: this.condition_id,
        planet: this.planet,
        house: this.house,
        detail_body: this.editorData2
      }
      this.CONDITION_TITLE = 'Update ' + this.planet + ' in ' + this.house

      AdminService.updateSignCondition(request).then((response) => {
        alert('Updated!')
        this.loadSign()
      })
    },

    loadCondition() {
      AdminService.loadSignCondition(this.sign_no, this.planet, this.house).then(
        (response) => {
          this.editorData2 = response['data']['detail_body']
          this.planet = response['data']['planet']
          this.house = response['data']['house']
        }
      )
    },

    loadConditionTalent() {
      AdminService.loadSignConditionTalent(this.sign_no, this.planet, this.houseTalent ,  this.selected_planet_nak_no).then(
        (response) => {
          this.editorData2 = response['data']['body']
          this.planet = response['data']['planet']
          this.houseTalent = response['data']['house']
          this.pre_title = response['data']['pre_title']
          this.pro_title = response['data']['pro_title']
          this.hora_order = response['data']['hora_order']
          this.talentInactive = response['data']['inactive'] === "true"
          this.selected_planet_nak_no = response['data']['nak_no']
        }
      )
    },

    saveCondition() {
      if (this.condition_id) {
        this.updateCondition()
      } else {
        const request = {
          hora_analysis_id: this.sign_no,
          planet: this.planet,
          house: this.house,
          detail_body: this.editorData2
        }
        AdminService.saveSignCondition(request).then((response) => {
          alert('Updated!')
          this.loadSign()
          this.newCondition()
        })
      }
    },

   saveConditionTalent() {
        const request = {
          hora_analysis_id: this.sign_no,
          nak_no: this.selected_planet_nak_no,
          planet: this.planet,
          pre_title: this.pre_title,
          pro_title: this.pro_title,
          hora_order: this.hora_order,
          talentInactive: this.talentInactive,
          house: this.houseTalent,
          detail_body: this.editorData2
        }
        AdminService.saveSignConditionTalent(request).then((response) => {
          alert('Updated!')
        })
    },


    saveSunSign() {
      const request = {
        sign_no: this.selected_sun_sign,
        body: this.sun_sign_body
      }
      AdminService.saveSunSignDetail(request).then((response) => {
        // console.log(response);
        alert('Updated!')

        this.loadSunSignDetail()
      })
    },

    saveMahaDasha() {
      const request = {
        planet: this.selected_md_planet,
        body: this.md_planet_body
      }
      AdminService.saveMahaDashaDetail(request).then((response) => {
        alert('Updated!')

        this.loadMahadasha()
      })
    },

    saveMoonSign() {
      const request = {
        sign_no: this.selected_moon_sign,
        body: this.moon_sign_body
      }
      AdminService.saveMoonSignDetail(request).then((response) => {
        alert('Updated!')

        this.loadMoonSignDetail()
      })
    },


    loadSign() {
      AdminService.loadSignDetail(this.selected_sign).then((response) => {
        this.sign_no = response['data']['sign_no']
        this.conditions = response['data']['conditions']
        this.selected_sign = response['data']['sign_no']
        this.selected_sign_screen = response['data']['sign_screen']
        this.editorData = response['data']['sign_desc']
          ? response['data']['sign_desc']
          : ''
      })
    },

    loadSunSign() {
      this.sun_sign_body = ''
      AdminService.loadSunSignDetail(this.selected_sun_sign).then((response) => {
        this.sun_sign_no = response['data']['sign_no']
        this.sun_sign_body = response['data']['body']
      })
    },

    loadMahadasha() {
      this.md_planet_body = ''
      AdminService.loadMahaDashaDetail(this.selected_md_planet).then((response) => {
        this.md_planet = response['data']['planet']
        this.md_planet_body = response['data']['body']
      })
    },

    loadMoonSign() {
      this.moon_sign_body = ''
      AdminService.loadMoonSignDetail(this.selected_moon_sign).then((response) => {
        this.moon_sign_no = response['data']['sign_no']
        this.moon_sign_body = response['data']['body']
      })
    },

    loadNakAsc() {
      this.nak_asc_body = ''
      AdminService.loadNakAscDetail(this.selected_nak_asc_no).then((response) => {
        this.nak_asc_no = response['data']['nak_no']
        this.nak_asc_body = response['data']['body']
      })
    },

    loadAK() {
      this.ak_planet_body = ''
      AdminService.loadAKDetail(this.selected_ak_planet).then((response) => {
        this.ak_planet = response['data']['planet']
        this.ak_planet_body = response['data']['body']
      })
    },

    saveNakAsc() {
      const request = {
        nak_no: this.selected_nak_asc_no,
        body: this.nak_asc_body
      }
      AdminService.saveNakAscDetail(request).then((response) => {
        alert('Updated!')
        this.loadNakAscDetail()
      })
    },

    saveAKDetail() {
      const request = {
        ak_planet: this.selected_ak_planet,
        body: this.ak_planet_body
      }
      AdminService.saveAKDetail(request).then((response) => {
        alert('Updated!')
        this.loadAKDetail()
      })
    }
    ,

    gc10LoadSign() {
      AdminService.loadGc10SignCondition(this.gc10_selected_sign).then(
        (response) => {
          this.gc10Editor = response['data']['sign_desc']
          this.gc10_selected_sign = response['data']['sign_no']
          this.gc10_sign = response['data']['sign_no']
        }
      )
    },


    saveGc10Sign() {
      const request = {
        sign_no: this.gc10_selected_sign,
        sign_desc: this.gc10Editor
      }
      AdminService.saveGc10SignDetail(request).then((response) => {
        alert('Updated!')
      })
    },

  }
}
</script>

